import React, { FunctionComponent } from 'react';
import { faClock, faFlag } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '.';

const BrassIconExtraHour: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faClock} />;

export { BrassIconExtraHour };
